import { useState } from "react";

import classNames from "classnames";
import Link from "next/link";
import { useRouter } from "next/router";

import { AnimatedSpinner } from "studio-design-system";

import DropdownIcon from "~/components/common/MarketingHeaderWithAuth/DropdownIcon";
import ProfilePill from "~/components/common/ProfilePill/ProfilePill";

import { useAuth } from "../../../hooks/auth/useAuth";
import { CartPill } from "../CartPill";
import { SearchBar } from "../Search";
import * as styles from "./MarketingHeaderWithAuth.css";

const DesktopNavigation = ({
  isUserLoggedIn,
  isCreator,
  showCreateClass,
  showMyClasses,
  showEarningsDashboard,
  onSignIn,
  onSignOut,
  handleCreateClass,
}: {
  isUserLoggedIn: boolean;
  isCreator: boolean;
  showCreateClass: boolean;
  showMyClasses: boolean;
  showEarningsDashboard: boolean;
  onSignIn: () => void;
  onSignOut: () => void;
  handleCreateClass: () => void;
}) => {
  const router = useRouter();
  const [showDropDown, setShowDropDown] = useState<boolean>(false);
  const { loadingCurrentUser, user } = useAuth();

  return (
    <nav className={styles.navigation}>
      <ul className={classNames(styles.navItems)}>
        {isUserLoggedIn && (
          <li>
            <Link
              href={"/library"}
              className={classNames(
                styles.navItemLink,
                router.pathname == "/library" && styles.activeLink,
              )}
            >
              My Library
            </Link>
          </li>
        )}

        <li>
          <Link
            href={"/browse"}
            className={classNames(
              styles.navItemLink,
              router.pathname == "/browse" && styles.activeLink,
            )}
          >
            Browse
          </Link>
        </li>
        <li className={styles.searchBarWrap}>
          <SearchBar />
        </li>
        {isUserLoggedIn && isCreator && (
          <li
            className={styles.navItemLinkForCreators}
            onMouseEnter={() => setShowDropDown(true)}
            onMouseLeave={() => setShowDropDown(false)}
          >
            <span className={classNames(styles.navItemLink, showDropDown && styles.activeLink)}>
              {"For Creators"}
            </span>
            <div className={styles.dropdownIconWrap}>
              <DropdownIcon color={showDropDown ? "white" : "#AFAFAF"} />
            </div>

            {showDropDown && (
              <div className={styles.dropDownContainer}>
                {showCreateClass && (
                  <>
                    {showMyClasses && (
                      <Link href={"/my-classes"} className={styles.dropdownItemLink}>
                        My Classes
                      </Link>
                    )}
                    <span className={styles.dropdownItemLink} onClick={() => handleCreateClass()}>
                      Create a Class
                    </span>
                  </>
                )}
                {showEarningsDashboard && (
                  <Link href={"/dashboard"} className={styles.dropdownItemLink}>
                    My Earnings Dashboard
                  </Link>
                )}
              </div>
            )}
          </li>
        )}

        <li className={classNames(styles.loginButton, isCreator && styles.loginButtonCreator)}>
          {/* {(!isUserLoggedIn || !isCreator) && (
                    <li>
                      <Link href={"/creators"}>
                        <span
                          className={classNames(
                            styles.navItemLinkRight,
                            router.pathname == "/creators" && styles.activeLink,
                          )}
                        >
                          {" "}
                          {FOR_CREATORS_TEXT}{" "}
                        </span>
                      </Link>
                    </li>
                  )} */}
          <CartPill />
          {loadingCurrentUser ? (
            <AnimatedSpinner />
          ) : isUserLoggedIn ? (
            <ProfilePill className={styles.profilePill} onLogout={onSignOut} />
          ) : (
            <button onClick={onSignIn} className={classNames(styles.navItemLinkLast, "nav-item")}>
              {" "}
              Log in{" "}
            </button>
          )}
        </li>
      </ul>
    </nav>
  );
};

export default DesktopNavigation;
